var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgSlot = function SvgSlot(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 34959"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 34958"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 4877",
    d: "M2 21.9999C2 16.4142 2 13.6213 2.78561 11.3761C4.19278 7.35463 7.35463 4.19278 11.3761 2.78561C13.6213 2 16.4142 2 22 2C27.5858 2 30.3787 2 32.6239 2.78561C36.6454 4.19278 39.8072 7.35463 41.2144 11.3761C42 13.6213 42 16.4142 42 21.9999C42 27.5856 42 30.3785 41.2144 32.6237C39.8072 36.6452 36.6454 39.807 32.6239 41.2142C30.3787 41.9998 27.5858 41.9998 22 41.9998C16.4142 41.9998 13.6213 41.9998 11.3761 41.2142C7.35463 39.807 4.19278 36.6452 2.78561 32.6237C2 30.3785 2 27.5856 2 21.9999Z",
    fill: "#161620"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Intersect",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.0689 41.9996H20.9311C16.0484 41.9965 13.4733 41.9481 11.3761 41.2143C7.35463 39.8071 4.19278 36.6452 2.78561 32.6238C2 30.3786 2 27.5857 2 22C2 16.4142 2 13.6214 2.78561 11.3762C4.19278 7.35472 7.35463 4.19286 11.3761 2.7857C12.7251 2.31367 14.2718 2.12526 16.5033 2.05005C18.7312 2.12541 20.2763 2.31392 21.624 2.78551C25.6454 4.19267 28.8072 7.35448 30.2144 11.3759C31 13.6211 31 16.414 31 21.9999V41.6341C29.1526 41.9688 26.7758 41.9972 23.0689 41.9996Z",
    fill: "#FFCE53"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 4878",
    x: 34,
    y: 11.9999,
    width: 2,
    height: 18.9999,
    fill: "#434A54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 4879",
    d: "M31 27.9995L38 29.9995V34.4995L31 36.9995V27.9995Z",
    fill: "#646D78"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 376",
    cx: 35,
    cy: 10.9999,
    rx: 3,
    ry: 2.99998,
    fill: "#FC3F1E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Intersect_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.06942 15.9999H24C25.1046 15.9999 26 16.8954 26 17.9999V34.9998C26 36.1044 25.1046 36.9998 24 36.9998H5.27607C4.20099 35.7189 3.35145 34.2409 2.78561 32.6238C2 30.3786 2 27.5857 2 22C2 19.512 2 17.5781 2.06942 15.9999Z",
    fill: "#F6BB43"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 4880",
    x: 14,
    y: 17.9999,
    width: 10,
    height: 16.9999,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Intersect_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.87544 34.9998C3.44244 34.2498 3.07653 33.4552 2.78561 32.6238C2 30.3786 2 27.5858 2 22C2 20.4733 2 19.1552 2.01604 17.9999H12V34.9998H3.87544Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21.9563 24.9002L21.2637 24.0647C21.1944 24.0004 21.079 23.979 20.9867 24.0218L20.7096 24.1504C20.0401 24.4503 19.3014 24.5146 18.5857 24.3218C18.2856 24.2361 17.9623 24.2146 17.6622 24.2146H16.2309C16.0923 24.2146 16 24.3003 16 24.4289V26.9142C16 27.0428 16.0923 27.1285 16.2309 27.1285H17.1543C17.2928 27.1285 17.3852 27.0428 17.3852 26.9142C17.3852 26.5714 17.6853 26.2929 18.0778 26.2929H18.7473L18.401 26.6785C17.593 27.5784 17.0158 28.6068 16.6926 29.7424C16.6926 29.7852 16.6926 29.8709 16.7388 29.9138C16.7849 29.9566 16.8542 29.9995 16.9235 29.9995H19.9247C20.0632 29.9995 20.1556 29.9138 20.1556 29.7852C20.1556 28.6068 20.5018 27.4499 21.1483 26.4214L21.9563 25.1359C22.0255 25.0716 22.0025 24.9859 21.9563 24.9002Z",
    fill: "#FC3F1E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M9.95629 24.9006L9.2637 24.065C9.19444 24.0007 9.07901 23.9793 8.98666 24.0222L8.70962 24.1507C8.04012 24.4507 7.30135 24.515 6.58568 24.3221C6.28555 24.2364 5.96234 24.215 5.66222 24.215H4.23086C4.09235 24.215 4 24.3007 4 24.4293V26.9146C4 27.0431 4.09235 27.1288 4.23086 27.1288H5.15432C5.29284 27.1288 5.38518 27.0431 5.38518 26.9146C5.38518 26.5718 5.68531 26.2933 6.07778 26.2933H6.74728L6.40098 26.6789C5.59296 27.5788 5.0158 28.6072 4.69259 29.7427C4.69259 29.7856 4.69259 29.8713 4.73876 29.9141C4.78494 29.957 4.8542 29.9998 4.92346 29.9998H7.92469C8.0632 29.9998 8.15555 29.9141 8.15555 29.7856C8.15555 28.6072 8.50185 27.4502 9.14826 26.4218L9.95629 25.1363C10.0255 25.072 10.0025 24.9863 9.95629 24.9006Z",
    fill: "#FC3F1E"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSlot, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/slot.35c25f3c.svg";
export { ForwardRef as ReactComponent };